const GuestLoginVariant = {
  key: 'guest_login',
  getSettings: componentSettings => ({
    ...componentSettings,
    useGuestLoginLayout: true
  })
};

export default GuestLoginVariant;
